import { render, staticRenderFns } from "./EditRequestDialog.vue?vue&type=template&id=198d1056&scoped=true&"
import script from "./EditRequestDialog.vue?vue&type=script&lang=js&"
export * from "./EditRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditRequestDialog.vue?vue&type=style&index=0&id=198d1056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d1056",
  null
  
)

export default component.exports